import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Target } from "lucide-react";
import { useEffect } from "react";
import { SessionResults } from "./ChampVisuelParameter";

export function FormResultats({
  setSessionResults,
  sessionsResults,
  autoSelectCells,
}: {
  sessionsResults: SessionResults[];
  setSessionResults: (sessionResult: SessionResults) => void;
  autoSelectCells: () => void;
}) {
  useEffect(() => {
    if (Array.isArray(sessionsResults) && sessionsResults.length > 0) {
      const sortedResults = sessionsResults
        .filter((option) => option.fiable)
        .sort(
          (a, b) =>
            new Date(b.sessionDate).getTime() -
            new Date(a.sessionDate).getTime()
        );

      if (sortedResults.length > 0) {
        setSessionResults(sortedResults[0]);
      }
    } else {
      console.error("selections is not an array or empty:", sessionsResults);
    }
  }, [sessionsResults, setSessionResults]);

  if (!Array.isArray(sessionsResults)) {
    console.error("selections is not an array:", sessionsResults);
    return null;
  }

  return (
    <div className="flex flex-col items-center w-full">
      {/* <div className="w-full max-w-lg p-6 bg-white border border-gray-200 rounded shadow-md"> */}
      <h2 className="mb-2 text-xl font-semibold text-center">Résultats</h2>
      <Select
        onValueChange={(value) => {
          const filteredSelection = sessionsResults.find(
            (option) => option.sessionDate === value
          ) as SessionResults;
          setSessionResults(filteredSelection);
        }}
      >
        <SelectTrigger
          onClick={(e) => {
            e.stopPropagation(); // Empêche la propagation du clic au composant sous-jacent
          }}
        >
          <SelectValue placeholder="Sélectionner" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Aucune sélection</SelectItem>
          {sessionsResults
            .filter((option) => option.fiable)
            .sort((a, b) => new Date(b.sessionDate).getTime() - new Date(a.sessionDate).getTime())
            .map((option) => (
              <SelectItem key={option.id} value={option.sessionDate}>
                {new Date(option.sessionDate).toLocaleDateString("fr-FR")} - {" "}
                {option.sessionType} {option.order} -{" "}
                {option.accountUsed}
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
      {/* </div> */}
      <Button
        onClick={autoSelectCells}
        className="bg-indigo-500 text-white rounded px-4 py-2 mt-4 w-full max-w-lg p-6"
      >
        <Target className="h-4 w-4 mr-2" />
        Auto-selection
      </Button>
    </div>
  );
}
